module.exports = __webpack_public_path__ + "static/media/clue-2.d21b9361.svg";